export class Vec2 {
    _x;
    _y;
    constructor(x, y) {
        this._x = x;
        this._y = y;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
    }
}

export class Vec3 {
    _x;
    _y;
    _z;
    constructor(x, y, z) {
        this._x = x;
        this._y = y;
        this._z = z;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
    }
}

export class Quat {
    _x;
    _y;
    _z;
    _w;
    constructor(x = 0, y = 0, z = 0, w = 1) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
    }
}

export class ClientControlsState {
    _move_direction;
    _jump;
    _sprint;
    _fire;
    _right_stick_input;
    constructor(move_direction = new Vec2(0, 0), jump = false, sprint = false, fire = false, right_stick_input = new Vec2(0, 0)) {
        this._move_direction = move_direction;
        this._jump = jump;
        this._sprint = sprint;
        this._fire = fire;
        this._right_stick_input = right_stick_input;
    }
    get move_direction() {
        return this._move_direction;
    }
    set move_direction(value) {
        this._move_direction = value;
    }
    get jump() {
        return this._jump;
    }
    set jump(value) {
        this._jump = value;
    }
    get sprint() {
        return this._sprint;
    }
    set sprint(value) {
        this._sprint = value;
    }
    get fire() {
        return this._fire;
    }
    set fire(value) {
        this._fire = value;
    }
    get right_stick_input() {
        return this._right_stick_input;
    }
    set right_stick_input(value) {
        this._right_stick_input = value;
    }
}

export class CollisionResult {
    _entityId;
    _normal;
    _toi;
    constructor(entityId = 0, normal = new Vec3(0, 0, 0), toi = 0) {
        this._entityId = entityId;
        this._normal = normal;
        this._toi = toi;
    }
    get entityId() {
        return this._entityId;
    }
    set entityId(value) {
        this._entityId = value;
    }
    get normal() {
        return this._normal;
    }
    set normal(value) {
        this._normal = value;
    }
    get toi() {
        return this._toi;
    }
    set toi(value) {
        this._toi = value;
    }
}
export class Camera {
    _position;
    _rotation;
    _fov_y;
    _z_near;
    _z_far;

    constructor(position = new Vec3(0, 0, 0), rotation = new Quat(0, 0, 0, 1), fov_y = 60, z_near = 0.1, z_far = 1000) {
        this._position = position;
        this._rotation = rotation;
        this._fov_y = fov_y;
        this._z_near = z_near;
        this._z_far = z_far;
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
    }
    get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        this._rotation = value;
    }
    get fov_y() {
        return this._fov_y;
    }
    set fov_y(value) {
        this._fov_y = value;
    }
    get z_near() {
        return this._z_near;
    }
    set z_near(value) {
        this._z_near = value;
    }
    get z_far() {
        return this._z_far;
    }
    set z_far(value) {
        this._z_far = value;
    }
}

